var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wraper"},[(_vm.courses == null)?_c('div',{attrs:{"id":"no-courses"}},[_c('h1',{attrs:{"id":"study-plan-title"}},[_vm._v("No hay Cursos")])]):_c('div',_vm._l((_vm.courses),function(course){return _c('div',[_c('view-inprogress',{attrs:{"courseId":course}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-544a0c66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/courses/myCourses/inProgress.vue
// module id = null
// module chunks = 